import { lopBoMonHocSinhListReducer } from './lopBoMonHocSinhReducer';
import { lopBoMonListReducer } from './lopBoMonListReducer';
import { combineReducers } from 'redux';
import { lopBoMonSoDiemReducer } from './lopBoMonSoDiemReducer';
export const lopBoMonReducer = combineReducers({
    lopBoMonList: lopBoMonListReducer,
    lopBoMonHocSinhList: lopBoMonHocSinhListReducer,
    lopBoMonSoDiem: lopBoMonSoDiemReducer
})